import { Script, ScriptStrategy } from 'gatsby';
import React from 'react';
import Footer from './footer/index';
import Header from './header/index';

interface LayoutProps {
    children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => (
    <>
        <Script src="//cdn.bc0a.com/autopilot/f00000000209368/autopilot_sdk.js" />
        <Script
            id="gtm"
            strategy={ScriptStrategy.idle}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
                __html: `
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({});
            (function(w,d,s,l,i){
                w[l]=w[l]||[];
                w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
                var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
                j.async=true;
                j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl+'';
                f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer', 'G-ZDEXF1GT8K');
            `,
            }}
        />
        <Script
            id="gtm-2"
            strategy={ScriptStrategy.idle}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
                __html: `
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({});
            (function(w,d,s,l,i){
                w[l]=w[l]||[];
                w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
                var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
                j.async=true;
                j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl+'';
                f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer', 'GTM-W2LKHJL');
            `,
            }}
        />
        <noscript
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
                __html: `
          <iframe title="GTM-ZDEXF1GT8K" src="https://www.googletagmanager.com/ns.html?id=G-ZDEXF1GT8K" height="0" width="0" style="display: none; visibility: hidden" aria-hidden="true"></iframe>
                  `,
            }}
        />
        <noscript
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
                __html: `
            <iframe title="GTM-W2LKHJL" src="https://www.googletagmanager.com/ns.html?id=GTM-W2LKHJL" height="0" width="0" style="display: none; visibility: hidden" aria-hidden="true"></iframe>
                    `,
            }}
        />
        <Header />
        <main>{children}</main>
        <Footer />
    </>
);

export default Layout;
